import { UserInvitationType } from '../models/UserStore/Invitation';

import { NOT_APPLICABLE_STRING } from './general';

export function getInvitationMessage(
  type: UserInvitationType | undefined,
): string {
  switch (type) {
    case UserInvitationType.PostSharing:
      return `shares the post with you!`;
    case UserInvitationType.UserSharing:
      return `invites you to explore and follow the JOYAJOY user!`;
    case UserInvitationType.ClassroomSharing:
      return `invites you to explore and follow the Club!`;
    case UserInvitationType.GameSetSharing:
      return `invites you to play the Journey!`;
    case UserInvitationType.SlideshowSharing:
      return `invites you to play the show!`;
    case UserInvitationType.GameSharing:
      return `invites you to play the Game!`;
    case UserInvitationType.LeaderboardTeamInvitation:
      return `invites you to join the Team and play in the Path Leaderboard.`;
    case UserInvitationType.MultiplayerGameSessionInvitation:
      return 'invites you to play the Game!';
    case UserInvitationType.MultiplayerGameSharing:
      return 'invites you to play the Game!';
    case UserInvitationType.FriendChallengeInvitation:
      return 'invites you to play the Game!';
    case UserInvitationType.Referral:
      return 'invites you to join JOYAJOY!';
    default:
      return NOT_APPLICABLE_STRING;
  }
}
